
import {ServerResponse} from 'common/interfaces';

export default class ResponseUtil {
  static getErrorStatusFromResponse = (error: any): ServerResponse => {
    if (error?.response?.data?.status) return error?.response?.data;
    return {
      status: {
        success: false,
        msg: 'Error!!!!'
      },
    };
  };

  static getTimeoutConfig(timeoutMs: number) {
    const abortController = new AbortController();
    const intervalId = setTimeout(
      () => abortController.abort(),
      timeoutMs || 0,
    );
    return {intervalId, signal: abortController.signal};
  }
}
